<template>
  <v-card outlined class="pa-2 ma-0">
    <v-card-title class="blue--text text--darken-2 font-weight-bold">
      <div style="display: flex; flex-direction: column;">
        <div style="display: flex; align-items: center;">
          <v-icon left color="blue darken-2">mdi-gift</v-icon>
          Cross-SKU Freebie
        </div>

        <subtitle class="font-italic text-caption grey--text">
          Buy {{ promoItem.buyQty }} Get {{ promoItem.getQty }}
        </subtitle>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-row>
        <v-col cols="12" sm="6">
          <v-list-item dense>
            <v-list-item-content>
              <v-list-item-title class="subtitle-2 grey--text text--darken-2">Free Quantity</v-list-item-title>
              <v-list-item-subtitle class="font-weight-medium">
                {{ promoItem?.quantity }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>

        <v-col cols="12" sm="6">
          <v-list-item dense>
            <v-list-item-content>
              <v-list-item-title class="subtitle-2 grey--text text--darken-2">Freebie Item</v-list-item-title>
              <v-list-item-subtitle>
                <span class="font-weight-bold">{{ promoItem.freebie?.stockCode }}</span>
                – {{ promoItem.freebie?.productName }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>


<script>
export default {
  name: 'CrossFreebie',
  props: {
    promoItem: { type: Object, required: true },
  },
}
</script>